// src/utils/accountManager.js
export const saveAccount = async (accountData) => {
  try {
    const accounts = await getSavedAccounts();
    // Match by both restaurantId and email
    const existingIndex = accounts.findIndex(a => 
      a.restaurantId === accountData.restaurantId && a.email === accountData.email
    );
    
    const updatedAccount = {
      ...accountData,
      lastUsed: new Date().toISOString()
    };

    if (existingIndex >= 0) {
      accounts[existingIndex] = updatedAccount;
    } else {
      accounts.push(updatedAccount);
    }

    accounts.sort((a, b) => new Date(b.lastUsed) - new Date(a.lastUsed));
    localStorage.setItem('savedAccounts', JSON.stringify(accounts));
    return accounts;
  } catch (error) {
    console.error('Account save error:', error);
    throw error;
  }
};

export const getSavedAccounts = async () => {
  try {
    return JSON.parse(localStorage.getItem('savedAccounts') || '[]');
  } catch (error) {
    console.error('Account load error:', error);
    return [];
  }
};

export const removeAccount = async (restaurantId) => {
  try {
    const accounts = await getSavedAccounts();
    const filtered = accounts.filter(a => a.restaurantId !== restaurantId);
    localStorage.setItem('savedAccounts', JSON.stringify(filtered));
    return filtered;
  } catch (error) {
    console.error('Account removal error:', error);
    throw error;
  }
};
